import React from 'react'
import styled from 'styled-components'

const Svg = styled.svg`
  path, circle {
    transition: all 800ms;
  }
`

export default ({ fillColor, strokeColor }) => (
  <Svg width="35" height="35" viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <circle fill={fillColor || '#fff'} cx="17.5" cy="17.5" r="17.5" />
      <g transform="translate(11 10)" stroke={strokeColor || '#004178'}>
        <circle cx="5.5" cy="5.5" r="5.5" />
        <path d="M9.417 9.417l3.773 3.773" strokeLinecap="square" />
      </g>
    </g>
  </Svg>
);



// WEBPACK FOOTER //
// ./src/ui/components/generic/IconSearch.js